import { onINP } from "web-vitals/attribution";

function sendToGoogleAnalytics({ name, delta, value, id, attribution }) {
	const eventParams = {
		value: delta,
		metric_id: id,
		metric_value: value,
		metric_delta: delta,
	};
	switch (name) {
		case "INP": {
			eventParams.debug_target = attribution.interactionTarget;
			eventParams.debug_type = attribution.interactionType;
			eventParams.debug_time = attribution.interactionTime;
			eventParams.debug_input_elay = attribution.inputDelay;
			eventParams.debug_presentation_delay = attribution.presentationDelay;
			eventParams.debug_processing_duration = attribution.processingDuration;
			let debug_script = "";
			let max_duration = 0;
			for (const entry of attribution.longAnimationFrameEntries) {
				for (const script of entry.scripts) {
					if (script.duration > max_duration) {
						max_duration = script.duration;
						debug_script = script.sourceURL;
					}
				}
			}
			if (max_duration > 0) {
				eventParams.debug_script_duration = max_duration;
			}
			eventParams.debug_script = debug_script;
			break;
		}
	}
	if (typeof gtag !== "undefined") {
		gtag("event", name, eventParams);
	} else {
		console.log("event", name, eventParams);
	}
}
onINP(sendToGoogleAnalytics);

// import { onCLS, onLCP } from "web-vitals/attribution";
// onLCP(({ name, delta, value, id, attribution }) => {
// 	console.log("LCP", attribution);
// });
// onCLS(({ name, delta, value, id, attribution }) => {
// 	console.log("CLS", attribution);
// });
